import { createSelector } from "reselect";
export const getData = state => state.app?.sessionUserData;
export const getDataItem = key => createSelector(getData, data => data?.[key]);